import React from 'react';
import { Shield, Scale, Award, BookOpen, Briefcase } from 'lucide-react';

const TrustedBySection = () => {
  const badges = [
    { icon: Shield, label: 'USPTO Registered' }, { icon: Scale, label: 'Licensed Attorneys' },
    { icon: Award, label: 'Trusted Nationwide' }, { icon: BookOpen, label: 'Federal Filing' },
    { icon: Briefcase, label: 'Business Formation' },
  ];
  return (
    <section className="py-8 bg-wine-950 border-y border-wine-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {badges.map((b) => (
            <div key={b.label} className="flex items-center gap-2.5 text-wine-400 hover:text-wine-200 transition-colors">
              <b.icon className="w-5 h-5 text-gold-500" strokeWidth={1.5} />
              <span className="text-xs font-semibold uppercase tracking-wider">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
